import * as React from "react";
import type { SVGProps } from "react";

const SvgSummaryFooterGeneralChat = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={34}
    height={25}
    viewBox="0 0 34 25"
    {...props}
  >
    <path
      fill="#55449A"
      fillRule="evenodd"
      d="M16.065 8.953a2.965 2.965 0 0 0-2.958 2.963v5.241a2.964 2.964 0 0 0 2.958 2.963h6.398c.145 0 .286.05.399.143l2.833 2.331v-1.853a.63.63 0 0 1 .639-.629l.576.008a2.23 2.23 0 0 0 2.222-2.229v-5.975a2.964 2.964 0 0 0-2.958-2.963zm10.26 15.604a.63.63 0 0 1-.4-.143l-3.688-3.034h-6.172a4.224 4.224 0 0 1-4.216-4.223v-5.241a4.224 4.224 0 0 1 4.216-4.222h10.109a4.223 4.223 0 0 1 4.215 4.222v5.975a3.49 3.49 0 0 1-3.436 3.489v2.547a.63.63 0 0 1-.629.63zm-18.07-7.694a.63.63 0 0 1-.629-.63v-2.547c-1.885-.034-3.401-1.585-3.401-3.488V4.223C4.226 1.895 6.1 0 8.406 0H18.4c2.305 0 4.18 1.895 4.18 4.223v1.86a.63.63 0 0 1-.629.63.63.63 0 0 1-.629-.63v-1.86c0-1.634-1.31-2.963-2.922-2.963H8.405c-1.61 0-2.921 1.33-2.921 2.963v5.975c0 1.229.985 2.229 2.196 2.229l.567-.01a.633.633 0 0 1 .638.631v1.844l.669-.555a.629.629 0 1 1 .803.969l-1.699 1.412a.63.63 0 0 1-.402.145m9.477-1.75h-2.196a.629.629 0 1 1 .001-1.259h2.195a.63.63 0 0 1 0 1.26m4.49 0h-2.197a.63.63 0 0 1 .001-1.26h2.195a.63.63 0 0 1 0 1.26m4.49 0h-2.197a.629.629 0 0 1 0-1.26h2.196a.63.63 0 0 1 0 1.26"
    />
  </svg>
);
export default SvgSummaryFooterGeneralChat;
